import React from 'react';

// components
import {CardBorder} from '../../../../shared/components';

// styles
import {
  CardArticleBottom,
  CardArticleDescription,
  CardArticleTitle,
  CardArticleTop,
  CardArticleWrapper,
  IconPlaceholder,
  ThumbnailImg,
  IconPlaceholderWrapper,
} from './CardArticle-styles';
import {TextColors} from '../../../../shared/styles';

// types
import {ArticlePreview} from '../../../../shared/services/ApiService/types';

type Props = {
  article: ArticlePreview;
};

const CardArticle = ({ article }: Props) => {
  return (
    <CardBorder variant="white" hasHoverEffect>
      <CardArticleWrapper to={`/articles/${article.type?.toLowerCase()}/${article.id}`}>
        {(article.type?.toLowerCase() === "blog" && !article.thumbnailUrl) ? null : (
          <CardArticleTop>
            {article.thumbnailUrl ? (
              <ThumbnailImg src={article.thumbnailUrl} alt={article.title} />
            ) : (
              <IconPlaceholderWrapper>
                <IconPlaceholder />
              </IconPlaceholderWrapper>
            )}
          </CardArticleTop>
        )}
        <CardArticleBottom>
          <CardArticleTitle bold="bold">{article.title}</CardArticleTitle>
          <CardArticleDescription color={TextColors.secondary}>
            {article.description}
          </CardArticleDescription>
        </CardArticleBottom>
      </CardArticleWrapper>
    </CardBorder>
  );
};

export default CardArticle;
